import * as React from "react";
import {
  Button,
  Chip,
  Box,
  Stack,
  Typography,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import {
  CustomDetailsList,
  Loader,
  usePermission,
  CustomeDialog,
  DeleteModal,
} from "../../../shared";
import { useNavigate, useParams } from "react-router-dom";
import { ProductSizeDialog } from "./ProductSizeDialog";
import SimpleReactValidator from "simple-react-validator";
import { MultiLanguageNameTable } from "../../Category";
import { ProductMultiVariantTable } from "./ProductMultiVariantTable";

export const GeneralList = (props) => {
  const {
    data,
    varients,
    globalData,
    productNamings,
    productNamingsLoading,
    regionState,
    HandleVarientChange,
    handleCreateAndUpdatevarient,
    handleModal,
    handleDeleteVariant,
    handleDefaultVariant,
    tenantPreferredLanguages,
  } = props;
  const { details, isLoading } = data;
  const isEdit = usePermission("product-modify");
  const navigate = useNavigate();
  const { id } = useParams();
  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );
  const onSubmit = () => {
    if (validator.current.allValid()) {
      varients.id
        ? handleCreateAndUpdatevarient("edit", id)
        : handleCreateAndUpdatevarient("add", id);
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const columns = [
    {
      title: "Colour Code",
      accessor: (row) => {
        return (
          <Stack direction="row" gap={2}>
            {row.colour}
            <Box
              sx={{
                width: 25,
                height: 25,
                mr: "20px",
                borderRadius: "12px",
                backgroundColor: row.colour,
              }}
            />
          </Stack>
        );
      },
    },
    {
      title: "Short Description",
      accessor: "short_description",
    },
    {
      title: "Product Type",
      accessor: "product_type",
    },
    {
      title: "Category",
      accessor: (row) => {
        return row.category.name;
      },
    },
    {
      title: "Energy-Average Qty per Serve (kJ)",
      accessor: (row) => {
        return row.kilojoules || row.kilojoules == 0
          ? `${row.kilojoules} kJ`
          : "";
      },
    },
    {
      title: "Product Tags",
      hidden: (row) => {
        return row.product_type === "modifier" ? true : false;
      },
      accessor: (row) => {
        return (
          <Box>
            {row.tags.map((data, index) => {
              return (
                <Chip
                  key={index}
                  sx={{
                    mr: 1,
                    borderRadius: "12px",
                    background: "rgba(0, 0, 0, 0.16)",
                  }}
                  label={data}
                  variant="filled"
                  size="small"
                />
              );
            })}
          </Box>
        );
      },
    },
    {
      title: "Marketing Tags",
      accessor: (row) => {
        return (
          <Box>
            {row.marketing_tags.map((data, index) => {
              return (
                <Chip
                  key={index}
                  sx={{
                    mr: 1,
                    borderRadius: "12px",
                    background: "rgba(0, 0, 0, 0.16)",
                  }}
                  label={data}
                  variant="filled"
                  size="small"
                />
              );
            })}
          </Box>
        );
      },
    },
    {
      title: "PLU Code",
      accessor: "plu",
    },
    {
      title: "Old PLU Code",
      accessor: "old_plu",
    },
    {
      title: "Tax Group",
      accessor: (row) => {
        return row.tax_group?.name;
      },
    },
    {
      title: "Bump Screen Tags",
      accessor: (row) => {
        return (
          <Box>
            {row.bump_screen_tags.map((data, index) => {
              return (
                <Chip
                  key="index"
                  sx={{
                    mr: 1,
                    borderRadius: "12px",
                    background: "rgba(0, 0, 0, 0.16)",
                  }}
                  label={data}
                  variant="filled"
                  size="small"
                />
              );
            })}
          </Box>
        );
      },
      hidden: (row) => {
        return row.product_type === "modifier" ? true : false;
      },
    },
    {
      title: "Report Class Name",
      accessor: "redcat_plu_class",
    },
    {
      title: "Report Category",
      accessor: "redcat_category",
    },
    {
      title: "Loyalty Cards",
      accessor: (row) => {
        const findLoyaltyDetails = (data) => {
          return globalData.loyalty_cards.loyalty_card_types.find(
            (cardDetails) => cardDetails.value === data,
          );
        };

        return (
          <Box>
            {row.loyalty_card_type_id?.map((data, index) => {
              const details = findLoyaltyDetails(data);

              return (
                <Chip
                  key={index}
                  sx={{
                    mr: 1,
                    borderRadius: "12px",
                    background: "rgba(0, 0, 0, 0.16)",
                  }}
                  label={details?.label ?? ""}
                  variant="filled"
                  size="small"
                />
              );
            })}
          </Box>
        );
      },
    },
    {
      title: "Product Sticker Printing",
      accessor: (row) => {
        return row.sticker_printing ? "ON" : "OFF";
      },
      hidden: (row) => {
        return row.product_type === "retail" || row.product_type === "platter"
          ? false
          : true;
      },
    },
  ];

  const dataColumns =
    details?.product_type === "bundle"
      ? columns.filter((v) => v.title !== "Bump Screen Tags")
      : columns;

  const multiLanguageColumns = [
    {
      head: "Language",
      accessor: "lang",
      sx: { width: "16%", minWidth: "150px" },
    },
    {
      head: "Product Name",
      accessor: "locale_name",
      sx: { width: "42%" },
    },
    {
      head: "Product Short Name",
      accessor: "locale_alias",
      sx: { width: "42%" },
    },
  ];
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <CustomDetailsList
            columns={dataColumns}
            data={details}
            title="General"
            customHeader={
              <Stack p="24px" gap="16px">
                <Typography fontSize="16px" fontWeight={600}>
                  Multilingual Names
                </Typography>
                <MultiLanguageNameTable
                  rowBorder
                  columns={multiLanguageColumns}
                  data={productNamings}
                  loading={productNamingsLoading}
                />
              </Stack>
            }
            footer={
              <Stack direction="row" justifyContent="flex-end" p="16px">
                {isEdit && (
                  <Button
                    size="medium"
                    variant="text"
                    onClick={() => navigate(`/products/edit/${id}`)}
                    disabled={["gift_card", "delivery"].includes(
                      data.details?.product_type,
                    )}
                  >
                    Edit
                  </Button>
                )}
              </Stack>
            }
          />

          {details.product_type !== "modifier" && (
            <ProductMultiVariantTable
              variants={details.variants}
              tenantPreferredLanguages={tenantPreferredLanguages}
              regionState={regionState}
              handleDefaultVariant={handleDefaultVariant}
              handleModal={handleModal}
              isDisabled={["gift_card", "delivery"].includes(
                data.details?.product_type,
              )}
              onCreate={() => handleModal("varient-add", true)}
            />
          )}
          {/* <Card sx={{ p: "32px 24px", mb: "24px" }}>

            <Stack>
              <Typography variant="subtitle1" fontWeight={600}>
                Dynamic Link
              </Typography>
            </Stack>
            <Stack mt="24px">
              <Button variant="contained" sx={{ width: "fit-content" }}>Create Dynamic Link</Button>
            </Stack>
          </Card> */}
          <CustomeDialog
            open={varients.isOpen}
            handleClose={() => handleModal("varient-add", false)}
            PaperProps={{
              sx: {
                width: "423px",
                maxHeight: "80vh",
                p: "16px",
                overflowY: "auto",
              },
            }}
            title="Product Variants"
            content={
              <ProductSizeDialog
                HandleVarientChange={HandleVarientChange}
                data={varients.data}
                onSubmit={onSubmit}
                validator={validator}
                variants={details.variants}
                isBusy={varients.isBusy}
                tenantPreferredLanguages={tenantPreferredLanguages}
                regionState={regionState}
              />
            }
          />
          <DeleteModal
            open={varients.isDelete}
            handleClose={() => handleModal("varient-delete", false, null)}
            onConfirm={handleDeleteVariant}
          />
        </>
      )}
    </>
  );
};
